// Admin-ledger helpers that are pure enough to unit-test under node
// (tests/investment-v2/activity-export.test.mjs): who logged a row, and the
// CSV shape of a filtered set.

// Who logged the movement behind a row, as a name the admin recognises:
//   an investor / sub-account → their name; an admin acting on the
//   investor's behalf → "Admin"; nothing recorded → "Agent / imported"
//   (the Taekus fetch, the email agent, or a history import).
export function loggedByLabel(e, byId = {}) {
  if (e.enteredByMemberId && byId[e.enteredByMemberId]) return byId[e.enteredByMemberId].name;
  if (e.enteredByRole === 'admin') return 'Admin';
  if (e.enteredByRole === 'executor') return byId[e.member]?.name || 'Investor';
  return 'Agent / imported';
}

export const CSV_COLUMNS = [
  'Date', 'Household', 'Member', 'From', 'To', 'Amount moved', 'Rate', 'Value',
  'Kareem share', 'Investor share', 'Value held by', 'Status', 'Logged by', 'Event id', 'Movement id',
];

const cell = (v) => {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
};

export function rowToCsv(e, byId = {}) {
  const name = (id) => (id && byId[id] ? byId[id].name : (id || ''));
  const held = e.custody === 'pool' ? 'Kareem (pool)' : e.custody === 'investor' ? 'Investor' : '';
  const status = e.movementStatus === 'pending' ? 'Awaiting Kareem'
    : e.settleType === 'payout' ? 'Payout from Kareem' : e.settleType === 'payment' ? 'Payment to Kareem' : e.settleType === 'waiver' ? 'Waived by Kareem'
    : e.noValue ? 'No value on this leg' : 'Value generated';
  return [
    String(e.eventDate || '').slice(0, 10),
    name(e.household || e.member),
    name(e.member),
    e.srcLabel || e.srcKind || '',
    e.dstLabel || e.dstKind || '',
    Number(e.amount || 0).toFixed(2),
    e.noValue ? '' : Number(e.rate || 0),
    Number(e.value || 0).toFixed(2),
    Number(e.kareem || 0).toFixed(2),
    Number(e.investor || 0).toFixed(2),
    held,
    status,
    loggedByLabel(e, byId),
    e.noValue ? '' : e.id,
    e.movementId || '',
  ].map(cell).join(',');
}

// The filtered set, newest first as rendered. A BOM so Excel reads UTF-8
// (names with diacritics, the arrow in nothing — but "→" would otherwise
// break the first time a route label carries one).
export function toCsv(rows, byId = {}) {
  return '﻿' + [CSV_COLUMNS.join(','), ...rows.map((e) => rowToCsv(e, byId))].join('\r\n') + '\r\n';
}

export function csvFilename(f = {}, byId = {}, today = new Date()) {
  const day = today.toISOString().slice(0, 10);
  const who = f.who && byId[f.who] ? '-' + String(byId[f.who].name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : '';
  return `activity-${day}${who}.csv`;
}

// Browser-only: hand the CSV to the viewer as a file.
export function downloadCsv(text, filename) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.style.display = 'none';
  document.body.appendChild(a); a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
}
